import {
  ActionsPopup,
  ChipBadge,
  HwProceedButton,
  IStyles,
  InputField,
  Loader,
  MobilePopup,
  NoContentCard,
  cloneObject,
  deserify,
  formatErrorMessages,
  getDeviceType,
  getFileExtensionType,
  getFileSizeInMB,
  getFileType,
  getHumanReadableTimestampString,
  getLocalStorage,
  getMediaBasePath,
  pxToRem,
  pxTovW,
  theme,
  toStringBloomLevel,
  uploadFile,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  InputAdornment,
  MenuItem,
  Pagination,
  Select,
  TextField,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useGlobalContext } from '../../../../app/Context/GlobalContextProvider';

import { Close, SearchSharp } from '@mui/icons-material';
import {
  BloomLevelEnum,
  Question,
  Question_QuestionEnum,
} from '@protos/content_management/content.db_pb';
// import { ModuleFilteredQuestions } from '@protos/learning_management/lms.hw.teacher.apis_pb';
import {
  AssessmentCreationEnum,
  ModuleFilteredQuestions,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../reduxStore/reduxHooks';
import {
  bloomLevelValuesArray,
  calculateMinMaxTime,
  difficultyValuesArray,
  questionValuesArray,
  toBloomLevelEnum,
  toDifficultyEnum,
  toQuestionEnum,
  toStringQuestion,
  totalNoQuestions,
} from '../../../../utils/functions';
import { interactionEvent } from '../../../Auth/auth.events';
import {
  getAssessmentTypeName,
  JEE_MARKING_SCHEME_ALLOWED_TYPES,
  rearrangeTaskInfoArrayAfterAddition,
} from '../ReviewAssessment/functions';
import {
  addModuleFilteredQuestion,
  resetAssessmentFlowState,
  setFilteredQuestions,
  setSelectedTasksInfo,
  deleteModuleFilteredQuestionsById,
  setFAQuestionModuleMap,
  CustomUploadFileResponse,
} from '../../../Assessment/reducer/assessmentFlow.slice';
import QuestionsBank from './components/QuestionsBank';
import { useDownloadContext } from '../../../../app/Context/DownloadContextProviderV2';
import {
  AssessmentEnum,
  CloudUpload,
  MarkingSchemeEnum,
  QuestionModuleMap,
} from '@protos/learning_management/lms.db_pb';
import QuestionContainerShimmer from './components/Shimmer';
import { HOME } from '../../../../routeHandling/RoutesNomenclature';
import { EditWarningPopup } from '../../../../components/EditWarningPopup';
import {
  createChapterList,
  createTopicList,
} from '../../utils/questionBank.utils';
import { rearrangeTaskInfoArrayAfterDeletion } from '../ReviewAssessment/functions';
import { ModifiedSelectMenu } from './components/ModifiedSelectMenu';
import {
  setToastInfo,
  setToastInfoV2,
} from '../../../Home/reducer/homeDashboard.slice';
import { IUploadStatusMessage } from '../../components/UploadQuestions/UploadErrorCard';
import {
  FileUploadPurpose,
  MimeEnum,
  SignedUrlReponse,
} from '@protos/learning_management/lms.common.apis_pb';
import { APIResponse_StatusEnum } from '@protos/common/common.db_pb';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import styled from '@emotion/styled';
import { AddQuestionsPopup } from '../../components/UploadQuestions/AddQuestionPopup';
import { Timestamp } from '@bufbuild/protobuf';

const styles: IStyles = {
  root: {
    bgcolor: 'neutral.paleGrey',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: pxToRem(20), md: pxTovW(40) },
    padding: {
      xs: pxToRem(11),
      md: pxToRem(20),
      lg: `${pxTovW(15)} ${pxTovW(240)} ${pxTovW(15)} ${pxTovW(200)}`,
    },
    boxSizing: 'border-box',
    maxHeight: {
      xs: `calc(100vh - ${pxToRem(60)})`,
      md: `calc(100vh - ${pxTovW(100)})`,
    },
    overflow: { md: 'hidden', xs: 'auto' },
  },
  leftPanel: {
    flexBasis: { md: '45%', lg: pxTovW(615) },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(20) },
    overflowY: 'scroll',
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(20) },
    padding: {
      md: `${pxTovW(30)} ${pxTovW(40)}`,
    },
    bgcolor: 'common.white',
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // borderBottom: { md: '1px solid grey' },
    paddingBottom: pxTovW(20),
  },
  textBox: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: { xs: pxToRem(10), md: pxTovW(0) },
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    '& > * ': { display: 'inline' },
  },
  questionBank: {
    bgcolor: 'common.white',
    padding: { md: pxTovW(30) },
    paddingBottom: { xs: pxToRem(150), md: 0 },
    borderRadius: { xs: pxToRem(30), md: pxTovW(30) },
    // border: '1px solid red',
    // overflowY: 'scroll',
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
  },
  rightPanel: {
    display: { xs: 'none', md: 'block' },
    flexBasis: { md: '50%', lg: pxTovW(822) },
    gap: { xs: pxToRem(20), md: pxTovW(20) },
    overflowY: 'scroll',
    paddingBottom: { xs: pxToRem(50), md: pxTovW(70) },
    justifyContent: 'right',
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(8), md: pxTovW(10) },
  },
  paginationStyle: {
    boxSizing: 'border-box',
    borderTopLeftRadius: { xs: pxToRem(10), md: pxTovW(10) },
    borderTopRightRadius: { xs: pxToRem(10), md: pxTovW(10) },
    backgroundColor: '#F5FAFF',
    border: '1px solid #007CDC69',
    paddingY: { xs: pxToRem(8), md: pxTovW(18) },
    position: 'absolute',
    bottom: { xs: pxToRem(80), md: '0' },
    width: '100%',
    maxWidth: { xs: '95vw', md: '48%', lg: pxTovW(822) },
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1000,
  },
};

const questionTypes = Object.values(Question_QuestionEnum).filter(
  (value) => typeof value === 'string'
);
interface IProps {
  setQuestionBankDisplayFlag: Dispatch<SetStateAction<boolean>>;
}
interface IChapter {
  name: string;
  chapterId: number;
}
interface ITopic {
  name: string;
  topicId: number;
}
interface IUserFilter {
  value: 'all' | 'teacher';
}
export default function SearchQuestions(props: IProps) {
  const { setQuestionBankDisplayFlag } = props;

  const MAX_FILE_LIMIT_MB = 50;

  const location = useLocation();
  const pathname = location.pathname;
  const assessmentName = getAssessmentTypeName(pathname);
  const isDiagnosticAssessment = (): boolean => assessmentName === 'DIAGNOSTIC';
  const isFormativeAssessment = (): boolean => assessmentName === 'FORMATIVE';
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const android = window.Android;
  const deviceType = getDeviceType();
  const { module_id } = useParams();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const isIpadOnly = !isMobile && isIpad;
  const teacher_id = getLocalStorage('userId');
  const [quesLoading, setQuesLoading] = useState(false);
  const [quesError, setQuesError] = useState(false);
  const { isOffline } = useDownloadContext();
  const pathSegments = location.pathname.split('/');
  const [loading, setLoading] = useState<'loading' | 'success' | 'error'>(
    'success'
  );
  const [userFilter, setUserFilter] = useState<IUserFilter>();
  const { class_subject_info } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );
  const { manage_mode_of_conduction } = deserify(
    useAppSelector((state) => state.manageHomework)
  );
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const [searchText, setSearchText] = useState<string | null>(null);
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    questions_count,
    filtered_questions,
    module_filtered_questions,
    fa_selected_chapter_data,
    fa_assessment_config,
    selected_tasks_info,
    selected_chapter,
    selected_topic,
    assesment_creation_type,
    fetched_assessment_details,
    fa_question_module_map,
  } = deserify(useAppSelector((state) => state.assessment));
  const questionModuleMap = fa_question_module_map || [];
  const { setSelectedFunction, setSelectedLogoClickHandler } =
    useGlobalContext();
  const {
    TeacherUploadQuestionV1ClientWithStatusCodeHandler,
    LmsCommonAPIServiceV2ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV7WithStatusCodeHandler,
  } = useCommonServiceClientContext();

  const [fetchedQuestionModuleMap, setFetchedQuestionModuleMap] = useState<
    QuestionModuleMap[]
  >([]);
  const [selectedModuleIds, setSelectedModuleIds] = useState<number[]>([]);
  const [filteredQuestionsList, setFilteredQuestionsList] = useState<
    ModuleFilteredQuestions | undefined
  >(filtered_questions);

  const [selectedDifficulty, setSelectedDifficulty] = useState<string | null>(
    null
  );
  const [selectedBloomLevel, setSelectedBloomLevel] = useState<string | null>(
    null
  );
  const [warningPopupOpen, setWarningPopupOpen] = useState(false);
  const [questionIdToDelete, setQuestionIdToDelete] = useState<
    string | undefined
  >(undefined);
  const [selectedQuestionType, setSelectedQuestionType] = useState<
    string | null
  >(null);
  const [chapterList, setChapterList] = useState(
    createChapterList(module_filtered_questions)
  );
  const [topicList, setTopicList] = useState(
    createTopicList({
      chapterList: createChapterList(module_filtered_questions),
      initialData: module_filtered_questions,
    })
  );
  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [quePerPage, setQuePerPage] = useState<number>(0);
  const [totalQuestions, setTotalQuestions] = useState<number>(0);

  const leftPanelScrollTopRef = useRef<HTMLDivElement | null>(null);
  const rightPanelScrollTopRef = useRef<HTMLDivElement | null>(null);
  const hasInitializedPageEffect = useRef(false);
  const mediumScreen = useMediaQuery(theme.breakpoints.up('md'));
  const [difficultyModalState, setDifficultyModalState] = useState(false);
  const [quesTypeModalState, setQuesTypeModalState] = useState(false);
  const [bloomLevelModalState, setBloomLevelModalState] = useState(false);
  const [questionUsageModalState, setQuestionUsageModalState] = useState(false);
  const [selectedQuestionUsage, setSelectedQuestionUsage] = useState<
    string | null
  >('All');
  const [openFileUploadPopup, setOpenFileUploadPopup] = useState(false);
  const [templateDownloading, setTemplateDownloading] = useState(false);
  const [FileUploading, setFileUploading] = useState(false);
  const [File, setFile] = useState<CustomUploadFileResponse | undefined>();
  const [uploadStatusMessage, setUploadStatusMessage] =
    useState<IUploadStatusMessage>({});

  // ------------------------------------------------------------

  const handleDifficultyChange = async (
    event: React.SyntheticEvent,
    newValue: string | null
  ) => {
    if (newValue) {
      await interactionEvent({
        url: 'Teacher_current_homework',
        context: 'Difficulty_level',
        name: newValue.toUpperCase(),
        isOffline: isOffline,
      });
    }
    setSelectedDifficulty(newValue);
    setSelectedPage(1);
  };

  // ------------------------------------------------------------

  const handleBloomLevelChange = async (
    event: React.SyntheticEvent,
    newValue: string | null
  ) => {
    setSelectedBloomLevel(newValue);
    setSelectedPage(1);
    // updateFilteredList(
    //   selectedDifficulty,
    //   selectedQuestionType,
    //   newValue,
    //   searchText
    // );
  };

  // ------------------------------------------------------------

  const handleQuestionTypeChange = async (
    event: React.SyntheticEvent,
    newValue: string | null
  ) => {
    if (newValue) {
      await interactionEvent({
        url: 'Teacher_current_homework',
        context: 'Difficulty_level',
        name: newValue.toUpperCase().replace(/ /g, '_'),
        isOffline: isOffline,
      });
    }
    setSelectedQuestionType(newValue);
    setSelectedPage(1);
  };

  // ------------------------------------------------------------

  const handleSearchTextChange = (newValue: string | null) => {
    // for cta close and backspace delete
    if (newValue === '' || newValue === null) {
      handleSearch(null);
      getModuleQuestions({}); // in case 'X' is clicked or manually cleared
    }
    setSearchText(newValue);
  };

  // ------------------------------------------------------------

  const handleSearch = (newValue: string | null) => {
    // console.log(newValue);
    setSearchText(newValue);
    updateFilteredList(selectedDifficulty, selectedQuestionType, newValue);
    setSelectedPage(1);
  };

  // ------------------------------------------------------------

  const updateFilteredList = (
    difficulty: string | null,
    questionType: string | null,
    searchText: string | null,
    newData?: ModuleFilteredQuestions
  ) => {
    let dataToChange: ModuleFilteredQuestions | undefined;
    if (newData) dataToChange = newData;
    else dataToChange = filtered_questions;

    if (difficulty === null && questionType === null && searchText === null) {
      // Both fields are cleared, show all questions
      setFilteredQuestionsList(dataToChange);
      return;
    }

    if (dataToChange) {
      const updatedList = dataToChange.questions.filter((e: Question) => {
        // const matchesDifficulty =
        //   difficulty === null ||
        //   e.questionMeta?.difficultyLevel === toDifficultyEnum(difficulty);
        const matchesQuestionType =
          questionType === null ||
          e.questionType === toQuestionEnum(questionType);
        const matchesText =
          searchText === null ||
          e.questionText.toLowerCase().includes(searchText.toLowerCase());

        // console.log(matchesText);
        // return matchesDifficulty && matchesQuestionType && matchesText;
        return matchesQuestionType && matchesText;
      });
      // console.log(updatedList);
      const newFilteredQuestionsList = cloneObject(dataToChange);
      if (newFilteredQuestionsList) {
        newFilteredQuestionsList.questions = cloneObject(updatedList);
        setFilteredQuestionsList(newFilteredQuestionsList);
      } else {
        setFilteredQuestionsList(dataToChange);
      }
    }
  };

  // ------------------------------------------------------------

  const getFlatMapOfChapterAndTopics = () => {
    const moduleIdCollected =
      fetched_assessment_details?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo.flatMap(
        (chapter) => [
          chapter.chapterId,
          ...chapter.topicInfo.map((topic) => topic.topicId),
        ]
      );

    return moduleIdCollected?.length ? moduleIdCollected : [Number(module_id)]; // fallback is included
  };

  // ------------------------------------------------------------

  const getFilterByPreviouslyUsed = (
    questionUsage: string | null
  ): boolean | undefined => {
    if (!questionUsage || questionUsage === 'All') return undefined;
    if (questionUsage === 'Previously Used') return true;
    if (questionUsage === 'Not Used') return false;
    return undefined;
  };

  // ------------------------------------------------------------

  const handleQuestionUsageChange = async (
    event: React.SyntheticEvent,
    newValue: string | null
  ) => {
    const value = newValue ?? 'All';
    if (newValue) {
      await interactionEvent({
        url: 'Teacher_current_homework',
        context: 'Question_usage',
        name: newValue.toUpperCase().replace(/\s+/g, '_'),
        isOffline: isOffline,
      });
    }
    setSelectedQuestionUsage(value);
    setSelectedPage(1);
  };

  // ------------------------------------------------------------

  const getQuestionTypeOptionsForFilter = (): Question_QuestionEnum[] => {
    if (selectedQuestionType) {
      return [toQuestionEnum(selectedQuestionType)];
    }
    if (
      assesment_creation_type?.asessmentType ===
      AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT
    ) {
      return fa_assessment_config?.QuestionTypes ?? [];
    }
    if (
      assesment_creation_type.markingScheme ===
      MarkingSchemeEnum.MARKING_SCHEME_JEE
    ) {
      return [...JEE_MARKING_SCHEME_ALLOWED_TYPES];
    }
    return questionValuesArray.map((type) => toQuestionEnum(type));
  };

  // ------------------------------------------------------------

  const getBloomLevelOptionsForFilter = (): BloomLevelEnum[] => {
    if (selectedBloomLevel) {
      return [toBloomLevelEnum(selectedBloomLevel)];
    }
    if (
      assesment_creation_type.markingScheme ===
      MarkingSchemeEnum.MARKING_SCHEME_JEE
    ) {
      return [];
    }
    if (
      assesment_creation_type?.asessmentType ===
      AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT
    ) {
      return fa_assessment_config?.bloomLevels ?? [];
    }
    return bloomLevelValuesArray.map((level) => toBloomLevelEnum(level));
  };

  // ------------------------------------------------------------

  const getModuleQuestions = async ({
    userId,
    moduleId,
    selectedChapterId,
    selectedTopicId,
    latestChapterIds,
    latestTopicIds,
  }: {
    userId?: bigint;
    moduleId?: string;
    selectedChapterId?: number;
    selectedTopicId?: number;
    latestChapterIds?: number[];
    latestTopicIds?: number[];
  }) => {
    let moduleIdsForFA: number[] = [];
    const chapterList = createChapterList(module_filtered_questions);
    const hasChapters = latestChapterIds?.length;
    const hasTopics = latestTopicIds?.length;
    if (hasChapters && !hasTopics) {
      // chapterIds only = [selected chapterIds, topicIds of selected chapterIds]
      const topicIdsOfChapters = createTopicList({
        chapterList: chapterList.filter((ch) =>
          latestChapterIds.includes(ch.id)
        ),
        initialData: module_filtered_questions,
      }).map((elem) => elem.id);
      moduleIdsForFA = [...latestChapterIds, ...topicIdsOfChapters];
    } else if (hasChapters && hasTopics) {
      // both received = [selected chapterIds, selected topicIds]
      moduleIdsForFA = [...latestChapterIds, ...latestTopicIds];
    } else if (!hasChapters && hasTopics) {
      // topicIds only = [selected topicIds]
      moduleIdsForFA = [...latestTopicIds];
    } else {
      // fallback = [all chapterIds, all topicIds]
      const allChapterIds = chapterList.map((ch) => ch.id);
      const allTopicIds = createTopicList({
        chapterList,
        initialData: module_filtered_questions,
      }).map((topic) => topic.id);
      moduleIdsForFA = [...allChapterIds, ...allTopicIds];
    }

    try {
      setQuesLoading(true);
      const response =
        await LmsAssessmentTeacherAPIServiceV7WithStatusCodeHandler.getModuleQuestionsWithFilters(
          {
            teacherId: teacher_id,
            subjectId: class_subject_info?.subjectId,
            schoolId: userId
              ? user_info?.schoolDetails[0]?.schoolId
              : undefined,
            createdByUserId: userId,
            // modeOfConduction: fetched_assessment_details?.modeOfConduction
            //   ? fetched_assessment_details?.modeOfConduction
            //   : assesment_creation_type?.modeOfConduction,
            modeOfConduction:
              assesment_creation_type?.creationType === 'Readymade'
                ? manage_mode_of_conduction
                : assesment_creation_type.modeOfConduction,
            moduleIds: fa_selected_chapter_data // To check if this is FA creation flow
              ? moduleIdsForFA
              : fetched_assessment_details
              ? selectedChapterId
                ? selectedTopicId
                  ? [Number(selectedChapterId), Number(selectedTopicId)]
                  : [Number(selectedChapterId)]
                : getFlatMapOfChapterAndTopics()
              : [Number(module_id)], // fallback
            requiredDifficultyTypes: selectedDifficulty
              ? [toDifficultyEnum(selectedDifficulty)]
              : [],
            requiredQuestionTypes: getQuestionTypeOptionsForFilter(),
            bloomLevels: getBloomLevelOptionsForFilter(),
            assessmentCreationType:
              isFormativeAssessment() || isDiagnosticAssessment()
                ? AssessmentCreationEnum.ASSESSMENT_CREATION_FORMATIVE
                : AssessmentCreationEnum.ASSESSMENT_CREATION_HOMEWORK,
            pageNumber: selectedPage,
            searchText: searchText || undefined,
            filterByPreviouslyUsed: getFilterByPreviouslyUsed(
              selectedQuestionUsage
            ),
          }
        );
      if (response.data) {
        const data = response.data;
        dispatch(setFilteredQuestions(data));
        setFetchedQuestionModuleMap(data.questionModuleMap || []);

        // setFilteredQuestionsList(data);
        updateFilteredList(
          selectedDifficulty,
          selectedQuestionType,
          searchText,
          data
        );

        setTotalPages(data.pagination?.totalPages || 0);
        setQuePerPage(data.pagination?.itemsPerPage || 0);
        setTotalQuestions(data.pagination?.totalItems || 0);
      }
      setQuesLoading(false);
    } catch (err) {
      console.log(err);
      setQuesLoading(false);
      setQuesError(true);
    }
  };

  // ------------------------------------------------------------

  const handleAndroidAppRefresh = () => {
    try {
      if (deviceType === 'android' && android?.disableAppRefresh) {
        android.disableAppRefresh();
        console.log('App refresh enabled on Android for home page');
      }
    } catch (error) {
      console.log('Failed to enable app refresh on Android:', error);
    }
  };

  // ------------------------------------------------------------

  const handleAddNewQuestion = (newQuestionId: string, question: Question) => {
    const newQuestionMap = fetchedQuestionModuleMap.find(
      (q) => q.questionId === newQuestionId
    );
    if (newQuestionMap) {
      questionModuleMap.push(newQuestionMap);
    }
    dispatch(setFAQuestionModuleMap(questionModuleMap));
    const list = cloneObject(module_filtered_questions);
    if (list?.questions?.some((q) => q.questionId === newQuestionId)) {
      // if question is already present
      return;
    }
    const isJEEMarking =
      assesment_creation_type.markingScheme ===
      MarkingSchemeEnum.MARKING_SCHEME_JEE;
    dispatch(addModuleFilteredQuestion(question));
    // rearranging the task info array
    const updatedTaskInfoModels = rearrangeTaskInfoArrayAfterAddition(
      newQuestionId,
      selected_tasks_info
    )?.map((task) => ({
      ...task,
      maxMarks: isJEEMarking
        ? 4
        : task.maxMarks ??
          question.question?.model?.value?.commonQuestionContent?.marks?.[0] ??
          1,
    }));
    dispatch(setSelectedTasksInfo(updatedTaskInfoModels));
  };

  // ------------------------------------------------------------

  const handleDeleteNewQuestion = (questionId: string) => {
    dispatch(deleteModuleFilteredQuestionsById(questionId));
    const newQuestionModuleMap = questionModuleMap.filter(
      (q) => q.questionId !== questionId
    );
    dispatch(setFAQuestionModuleMap(newQuestionModuleMap));
    // rearranging the task info array after deletion
    const updatedTaskInfoModels = rearrangeTaskInfoArrayAfterDeletion(
      questionId,
      selected_tasks_info
    );
    dispatch(setSelectedTasksInfo(updatedTaskInfoModels));
    dispatch(
      setToastInfo({
        label: 'Your question has been deleted successfully.',
        variant: 'info',
        open: true,
      })
    );
  };

  // ------------------------------------------------------------

  const totalMarks = (question?: Question[]) => {
    if (!question) {
      return 0;
    }
    const marks = question.reduce(
      (acc, curr) =>
        acc +
        (curr.question?.model.value?.commonQuestionContent?.marks[0] || 0),
      0
    );
    return marks;
  };

  // ------------------------------------------------------------

  const updateFile = async (initialFile: CustomUploadFileResponse) => {
    setFile(initialFile);
  };

  // ------------------------------------------------------------

  const FileUpload = async (filesToUpload: FileList) => {
    const file = filesToUpload[0];
    console.log('file:', file);
    if (!file) return;
    if (
      ![
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].includes(file.type)
    ) {
      dispatch(
        setToastInfoV2({
          label: 'Please upload a valid Excel file (.xls or .xlsx)',
          variant: 'error',
          open: true,
        })
      );

      return;
    }

    const tempUserUploads: CustomUploadFileResponse = {
      uploadFileData: new CloudUpload({
        gcpFileUrl: '',
        personId: user_info?.teacherProfileId,
        fileSizeInMb: getFileSizeInMB(file.size),
        isDeleted: false,
        externalWebResourceUrl: '',
        fileName: file.name,
        fileType: getFileType(file.type),
        fileExtensionType: getFileExtensionType(file.type),
        isUploaded: false,
        signedUrl: '',
      }),
      fileUploadStatus: 'pending',
      fileSize: file.size,
    };

    await updateFile(tempUserUploads);

    //! max file size to be 50 MB
    if (getFileSizeInMB(file.size) > MAX_FILE_LIMIT_MB) {
      tempUserUploads.uploadFileData.isUploaded = false;
      tempUserUploads.fileUploadStatus = 'Size Exceeded';
      dispatch(
        setToastInfoV2({
          label: 'File Size should be less than 50 MB',
          variant: 'error',
          open: true,
        })
      );
      return;
    }
    setFileUploading(true);
    try {
      const signedUrlResponse: SignedUrlReponse =
        await LmsCommonAPIServiceV2ClientWithStatusCodeHandler.getSignedUrlForFileUpload(
          {
            personId: user_info?.teacherProfileId,
            filesInfo: [
              {
                originalFilePath: file.name,
                mimeType: MimeEnum.MIME_XLSX,
                size:
                  getFileSizeInMB(file.size) < 0.01
                    ? 0.01
                    : getFileSizeInMB(file.size),
              },
            ],
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            fileUploadPurpose: FileUploadPurpose.FILE_UPLOAD_TEACHER_QUESTION,

            schoolId: user_info?.schoolDetails[0]?.schoolId || undefined,
          }
        );

      if (signedUrlResponse && signedUrlResponse.response.length > 0) {
        const signedUrl = getMediaBasePath(
          signedUrlResponse.response[0].signedUrl
        );
        const uploadSuccess = await uploadFile({ file, signedUrl });
        if (uploadSuccess.success === true) {
          tempUserUploads.uploadFileData.signedUrl = signedUrl;
          tempUserUploads.uploadFileData.isUploaded = true;
          tempUserUploads.fileUploadStatus = 'success';

          const response =
            await TeacherUploadQuestionV1ClientWithStatusCodeHandler.upsertTeacherQuestions(
              {
                gcsFilePath: signedUrl,
                schoolId: user_info?.schoolDetails[0]?.schoolId,
                teacherId: user_info?.teacherProfileId,
                moduleIds: fa_selected_chapter_data
                  ? [
                      ...chapterList.map((ch) => ch.id),
                      ...topicList.map((t) => t.id),
                    ]
                  : [Number(module_id)],
                subjectId: class_subject_info?.subjectId,
                sectionId: class_subject_info?.sectionId,
              }
            );

          if (response.status === APIResponse_StatusEnum.STATUS_SUCCESS) {
            tempUserUploads.uploadFileData.isUploaded = true;
            tempUserUploads.fileUploadStatus = 'success';
            setUploadStatusMessage({
              successMessage: response.message || 'File uploaded successfully',
            });
            getModuleQuestions({
              userId:
                userFilter?.value === 'teacher'
                  ? user_info?.teacherProfileId
                  : undefined,
            });
          } else {
            console.log(
              'response.validationErrors:',
              response.validationErrors
            );
            tempUserUploads.uploadFileData.isUploaded = false;
            tempUserUploads.fileUploadStatus = 'Upload Error';
            setUploadStatusMessage({ errors: response.validationErrors });
          }
        } else {
          tempUserUploads.uploadFileData.isUploaded = false;
          tempUserUploads.fileUploadStatus = 'Upload Error';
          dispatch(
            setToastInfoV2({
              label: `Error Occurred! Unable to upload the file.`,
              variant: 'error',
              open: true,
            })
          );
        }
        setFileUploading(false);
      } else {
        tempUserUploads.uploadFileData.isUploaded = false;
        tempUserUploads.fileUploadStatus = 'Upload Error';
        setUploadStatusMessage({ errors: ['Failed to get signed URL'] });
      }
    } catch (error: any) {
      console.log('error:', error);
      setFileUploading(false);
      tempUserUploads.uploadFileData.isUploaded = false;
      tempUserUploads.fileUploadStatus = 'Upload Error';
      setUploadStatusMessage({ errors: [formatErrorMessages(error.message)] });
    }
  };

  // ------------------------------------------------------------

  const downloadTemplate = async () => {
    // setTemplateDownloaded(true);
    setTemplateDownloading(true);
    try {
      dispatch(
        setToastInfoV2({
          label: `Downloading template.`,
          variant: 'success',
          open: true,
        })
      );

      const response =
        await TeacherUploadQuestionV1ClientWithStatusCodeHandler.downloadTeacherQuestionsTemplate(
          {
            subjectId: class_subject_info?.subjectId,
            teacherId: user_info?.teacherProfileId,
            sectionId: class_subject_info?.sectionId,
            schoolId: user_info?.schoolDetails[0]?.schoolId,
          }
        );

      console.log('response:', response);
      if (response.signedUrl) {
        const link = document.createElement('a');
        link.href = response.signedUrl;
        link.setAttribute('download', 'Question_Upload_Template.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTemplateDownloading(true);
      } else {
        dispatch(
          setToastInfoV2({
            label: `Error Occurred! Unable to download template.`,
            variant: 'error',
            open: true,
          })
        );
      }

      setTemplateDownloading(false);
    } catch (error) {
      // console.log('error:', error);
      dispatch(
        setToastInfoV2({
          label: `Error Occurred! Unable to download template.`,
          variant: 'error',
          open: true,
        })
      );
      setTemplateDownloading(false);
    }
  };

  // ------------------------------------------------------------

  const handleDelete = async (questionId: string) => {
    try {
      setLoading('loading');
      await TeacherUploadQuestionV1ClientWithStatusCodeHandler.deleteTeacherQuestions(
        {
          teacherId: user_info?.teacherProfileId,
          schoolId: user_info?.schoolDetails[0]?.schoolId,
          questionIds: [questionId],
        }
      );
      dispatch(
        setToastInfoV2({
          label: 'Question deleted successfully',
          variant: 'info',
          open: true,
        })
      );
      setLoading('success');
      getModuleQuestions({});
    } catch (error) {
      console.error('Error deleting question:', error);
      dispatch(
        setToastInfoV2({
          label: 'Error deleting question',
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setLoading('success');
    }
  };

  // ------------------------------------------------------------

  const handleLogoClick = () => {
    if (
      assesment_creation_type?.asessmentType ===
        AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT &&
      assesment_creation_type.creationType === 'Create'
    ) {
      setWarningPopupOpen(true);

      return;
    }
    dispatch(resetAssessmentFlowState());
    navigate(HOME);
  };

  const handleback = () => {
    setQuestionBankDisplayFlag(false);
  };

  // ------------------------------------------------------------

  useEffect(() => {
    setSelectedFunction(() => handleback);
    setSelectedLogoClickHandler(() => handleLogoClick);
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  // ------------------------------------------------------------

  useEffect(() => {
    getModuleQuestions({ moduleId: module_id });
  }, [
    selectedBloomLevel,
    selectedDifficulty,
    selectedQuestionType,
    selectedQuestionUsage,
  ]);

  // ------------------------------------------------------------

  useEffect(() => {
    if (leftPanelScrollTopRef.current) {
      leftPanelScrollTopRef.current.scrollTop = 0;
    }
    if (rightPanelScrollTopRef.current) {
      rightPanelScrollTopRef.current.scrollTop = 0;
    }
    if (!hasInitializedPageEffect.current) {
      hasInitializedPageEffect.current = true;
      return;
    }
    getModuleQuestions({ moduleId: module_id });
  }, [selectedPage]);

  // ------------------------------------------------------------

  useEffect(() => {
    try {
      if (deviceType === 'android' && android?.disableAppRefresh) {
        android.disableAppRefresh();
        console.log('App refresh enabled on Android for home page');
      }
    } catch (error) {
      console.log(
        'An error occurred while attempting to enable app refresh on Android:'
      );
    }
    return () => {
      try {
        if (deviceType === 'android' && android?.enableAppRefresh) {
          android.enableAppRefresh();
          console.log('App refresh enabled on Android for home page');
        }
      } catch (error) {
        console.log(
          'An error occurred while attempting to enable app refresh on Android:'
        );
      }
    };
  }, []);

  // ------------------------------------------------------------

  if (loading === 'loading') {
    return <Loader />;
  }

  return (
    <Box sx={styles.root}>
      <Box sx={styles.leftPanel} ref={leftPanelScrollTopRef}>
        <Box sx={styles.header}>
          <Box sx={styles.heading}>
            {/* <Typography variant="h1">My Homework</Typography> */}
            <Box sx={styles.textBox}>
              <Typography variant="h2">Question Bank </Typography>
              <Typography variant="h3">
                <ChipBadge
                  label={totalQuestions}
                  color="primary"
                  size="small"
                />
              </Typography>
            </Box>
            {mediumScreen ? (
              <Button
                variant="contained"
                color="secondary"
                sx={{
                  fontSize: {
                    md: pxToRem(10),
                    lg: pxToRem(16),
                  },
                }}
                onClick={async () => {
                  // navigate(`${HOMEWORK_REVIEW}/${module_id}`)
                  setQuestionBankDisplayFlag(false);
                  await interactionEvent({
                    context: 'question_bank',
                    name: 'BACK_TO_HW',
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                  handleAndroidAppRefresh();
                }}
              >
                Back to{' '}
                {assesment_creation_type?.asessmentType ===
                AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT
                  ? 'FA'
                  : 'HW'}
              </Button>
            ) : (
              <Box
                sx={{
                  display: { xs: 'block', md: 'none' },
                  position: 'fixed',
                  bottom: { xs: 5, md: 15 },
                  left: { xs: pxToRem(22), md: 0 },
                  margin: 'auto',
                  zIndex: '100',
                }}
              >
                <HwProceedButton
                  clickHandler={async () => {
                    // navigate(`${HOMEWORK_REVIEW}/${module_id}`)
                    setQuestionBankDisplayFlag(false);
                    await interactionEvent({
                      context: 'question_bank',
                      name: 'BACK_TO_HW',
                      pathSegments: pathSegments,
                      isOffline: isOffline,
                    });
                  }}
                  buttonTitle={`Back to ${
                    assesment_creation_type?.asessmentType ===
                    AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT
                      ? 'FA'
                      : 'HW'
                  }`}
                  tabs={[
                    {
                      quantity: `${totalNoQuestions(questions_count)}`,
                      title: 'Qs',
                    },
                    {
                      quantity: `${calculateMinMaxTime(questions_count).max}`,
                      title: 'Mins',
                    },
                    {
                      quantity: `${totalMarks(
                        module_filtered_questions?.questions
                      )}`,
                      title: 'Marks',
                    },
                  ]}
                />
              </Box>
            )}
          </Box>
          <Box>
            <InputField
              variant="outlined"
              fullWidth
              boldtext={true}
              onChange={(e) => handleSearchTextChange(e.target.value || null)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch(searchText)}
              defaultValue={null}
              value={searchText}
              sx={{
                borderRadius: { xs: pxToRem(30), md: pxTovW(40) },
                border: '1px solid #CCE6FE',
                '& > div': {
                  background:
                    searchText === '' || searchText === null
                      ? 'transparent'
                      : 'linear-gradient(to right, transparent 88%,#007cdc 88% 100%)',
                  padding: '0px',
                },
              }}
              placeholder="Search concepts or subtopics"
              InputProps={{
                startAdornment: (searchText === '' || searchText === null) && (
                  <InputAdornment position="start">
                    <SearchIcon
                      fontSize={isIpadOnly ? 'small' : 'large'}
                      color="primary"
                    />
                  </InputAdornment>
                ),
                endAdornment: searchText !== null && searchText !== '' && (
                  <InputAdornment position="end">
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '10px',
                      }}
                    >
                      <Box
                        sx={{
                          cursor: 'pointer',
                          border: '5px solid red',
                          // backgroundColor: 'black',
                        }}
                        onClick={() => handleSearchTextChange('')}
                      >
                        <IconButton>
                          <Close fontSize="medium"></Close>
                        </IconButton>
                      </Box>
                      <Box
                        sx={{
                          // backgroundColor: 'primary.main',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          handleSearch(searchText);
                          getModuleQuestions({});
                        }}
                      >
                        <IconButton>
                          <SearchSharp
                            fontSize="medium"
                            sx={{ color: 'darkblue' }}
                          ></SearchSharp>
                        </IconButton>
                      </Box>
                    </Box>
                  </InputAdornment>
                ),
              }}
              onClick={async () => {
                await interactionEvent({
                  url: 'Teacher_current_homework',
                  context: 'My_homework',
                  name: 'SEARCH',
                  isOffline,
                });
              }}
            />
          </Box>
          {/* <Box sx={{ display: { xs: 'block', md: 'none' }, width: '100%' }}>
            <Select
              value={userFilter || ''}
              onChange={(e) => {
                console.log('Selected filter:', e.target.value);
                setUserFilter({ value: e.target.value as 'all' | 'teacher' });

                getModuleQuestions({
                  userId:
                    e.target.value === 'teacher'
                      ? user_info?.teacherProfileId
                      : undefined,
                });
              }}
              displayEmpty
              renderValue={(filter) => {
                if (!filter.value) {
                  return <Typography color="text.disabled">Select</Typography>;
                }
                return filter.value === 'all' ? (
                  <Typography variant="cardText"> All Questions</Typography>
                ) : (
                  <Typography variant="cardText">
                    {' '}
                    Teacher Uploaded Questions
                  </Typography>
                );
              }}
              sx={{
                background: '#F5FAFF',
                width: { xs: '100%', md: pxTovW(332) },
                borderRadius: { xs: pxToRem(10), md: pxTovW(5) },
                marginLeft: 'auto',
                height: { xs: pxToRem(50), md: pxTovW(50), lg: pxTovW(65) },
                '.MuiOutlinedInput-notchedOutline': {
                  border: '2px solid #87C5FF',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: '2px solid #87C5FF',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: '2px solid #87C5FF',
                },
                boxShadow: 'none',
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    // maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                    // minHeight: { xs: 'max-content', md: 'max-content' },
                    backgroundColor: '#F8FCFF',
                    '&::-webkit-scrollbar': { display: 'none' },
                    padding: 0,
                    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
                    '& .MuiList-root': {
                      backgroundColor: '#F8FCFF',
                      maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                      padding: 0,
                    },
                    scrollbarWidth: 'thin',
                    minWidth: { xs: '95%', md: pxTovW(230) },
                    maxWidth: { xs: '95%', md: pxTovW(200), lg: pxTovW(150) },
                  },
                },
              }}
            >
              <MenuItem value="all">All Questions</MenuItem>
              <MenuItem value="teacher">Teacher Uploaded Questions</MenuItem>
            </Select>
          </Box> */}
          <Box
            sx={{
              display: 'flex',
              width: { xs: '95vw', md: 'unset' },
              gap: { md: pxTovW(15) },
              // paddingRight: { xs: pxToRem(5), md: pxToRem(0) },
              // paddingLeft: { xs: pxToRem(5), md: pxToRem(0) },
              boxSizing: 'border-box',
              // margin: 'auto',
              justifyContent: { md: 'space-around' },
              alignItems: 'center',
              // backgroundColor: 'red',
            }}
          >
            <Box
              sx={
                mobile
                  ? {
                      flexBasis: '50%',
                      display: 'flex',
                      justifyContent: 'center',
                    }
                  : { flexBasis: '50%' }
              }
            >
              {mediumScreen ? (
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  popupIcon={
                    <KeyboardArrowDownRoundedIcon
                      fontSize={mediumScreen ? 'large' : 'small'}
                      sx={{ color: 'text.disabled' }}
                    />
                  }
                  options={difficultyValuesArray}
                  value={selectedDifficulty}
                  onChange={handleDifficultyChange}
                  // disableClearable
                  sx={{
                    border: '1px solid #38FF92',
                    borderRadius: '7px',
                  }}
                  renderInput={(params) => (
                    <TextField
                      variant="filled"
                      {...params}
                      label="Difficulty Level"
                    />
                  )}
                />
              ) : (
                <Box
                  sx={{
                    padding: pxToRem(5),
                    display: 'flex',
                    width: pxToRem(155),
                    height: pxToRem(45),
                    border: '1px solid #38FF92',
                    borderRadius: '7px',
                    boxSizing: 'border-box',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                  }}
                  onClick={() => setDifficultyModalState(true)}
                >
                  <Typography
                    // {...params}
                    variant="h4"
                    sx={{
                      padding: pxToRem(5),
                      display: '-webkit-box',
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: 'horizontal',
                      overflow: 'hidden',
                    }}
                  >
                    {selectedDifficulty !== null
                      ? selectedDifficulty
                      : ' Difficulty Level'}
                  </Typography>
                  <KeyboardArrowDownRoundedIcon
                    sx={{
                      color: 'text.disabled',
                    }}
                  />
                </Box>
              )}
            </Box>
            <Box
              sx={
                mobile
                  ? {
                      flexBasis: '50%',
                      display: 'flex',
                      justifyContent: 'center',
                    }
                  : { flexBasis: '50%' }
              }
            >
              {mediumScreen ? (
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  popupIcon={
                    <KeyboardArrowDownRoundedIcon
                      fontSize="large"
                      sx={{ color: 'text.disabled' }}
                    />
                  }
                  options={
                    assesment_creation_type?.asessmentType ===
                    AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT
                      ? fa_assessment_config?.QuestionTypes.map(
                          (assessmentType) =>
                            toStringQuestion(
                              Question_QuestionEnum[assessmentType]
                            )
                        ) || []
                      : questionValuesArray
                  }
                  value={selectedQuestionType}
                  onChange={handleQuestionTypeChange}
                  // disableClearable
                  sx={{
                    border: '1px solid #38FF92',
                    borderRadius: '7px',
                  }}
                  renderInput={(params) => (
                    <TextField
                      variant="filled"
                      {...params}
                      label="Question Type"
                    />
                  )}
                />
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    width: pxToRem(155),
                    height: pxToRem(45),
                    border: '1px solid #38FF92',
                    borderRadius: '7px',
                    boxSizing: 'border-box',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                  }}
                  onClick={() => {
                    setQuesTypeModalState(true);
                    handleAndroidAppRefresh();
                  }}
                >
                  <Typography
                    // {...params}
                    variant="h4"
                    sx={{
                      padding: pxToRem(5),
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {selectedQuestionType !== null
                      ? selectedQuestionType
                      : 'Question Type'}
                  </Typography>
                  <KeyboardArrowDownRoundedIcon
                    sx={{
                      color: 'text.disabled',
                    }}
                  />
                </Box>
              )}
            </Box>
          </Box>
          {assesment_creation_type.markingScheme !==
            MarkingSchemeEnum.MARKING_SCHEME_JEE && (
            <Box
              sx={{
                display: 'flex',
                width: { xs: '95vw', md: 'unset' },
                boxSizing: 'border-box',
                justifyItems: 'flex-start',
                // backgroundColor: 'red',
              }}
            >
              <Box
                sx={
                  mobile
                    ? {
                        flexBasis: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                      }
                    : { width: '50%' }
                }
              >
                {mediumScreen ? (
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    popupIcon={
                      <KeyboardArrowDownRoundedIcon
                        fontSize={mediumScreen ? 'large' : 'small'}
                        sx={{ color: 'text.disabled' }}
                      />
                    }
                    options={
                      assesment_creation_type?.asessmentType ===
                      AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT
                        ? fa_assessment_config?.bloomLevels.map(
                            (bloomLevelType) =>
                              toStringBloomLevel(bloomLevelType)
                          ) || []
                        : bloomLevelValuesArray
                    }
                    value={selectedBloomLevel}
                    onChange={handleBloomLevelChange}
                    // disableClearable
                    sx={{
                      border: '1px solid #38FF92',
                      borderRadius: '7px',
                    }}
                    renderInput={(params) => (
                      <TextField
                        variant="filled"
                        {...params}
                        label="Bloom Level"
                      />
                    )}
                  />
                ) : (
                  <Box
                    sx={{
                      padding: pxToRem(5),
                      display: 'flex',
                      width: pxToRem(155),
                      height: pxToRem(45),
                      border: '1px solid #38FF92',
                      borderRadius: '7px',
                      boxSizing: 'border-box',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                    }}
                    onClick={() => setBloomLevelModalState(true)}
                  >
                    <Typography
                      // {...params}
                      variant="h4"
                      sx={{
                        padding: pxToRem(5),
                        display: '-webkit-box',
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'horizontal',
                        overflow: 'hidden',
                      }}
                    >
                      {selectedBloomLevel !== null
                        ? selectedBloomLevel
                        : ' Bloom Level'}
                    </Typography>
                    <KeyboardArrowDownRoundedIcon
                      sx={{
                        color: 'text.disabled',
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          )}

          {assesment_creation_type?.creationType === 'Create' &&
            assesment_creation_type.asessmentType ===
              AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: pxTovW(10), md: pxTovW(10) },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: pxToRem(20), md: pxTovW(21) },
                  }}
                >
                  {/* <Box sx={styles.selectContainer}>
                    <Typography variant="h4">Select Chapter</Typography>
                    <SelectMenu
                      placeholder="select"
                      value={
                        selected_chapter?.chapterTitle
                          ? `${selected_chapter.chapterNo}. ${selected_chapter.chapterTitle} `
                          : ''
                      }
                      clearIcon={true}
                      onChange={(value: string) => {
                        // Find the chapter object by matching the selected title
                        if (!value) {
                          dispatch(resetSelectedChapter());
                          dispatch(resetSelectedTopic());
                          getModuleQuestions({});
                        } else {
                          const selectedChapterObj =
                            module_filtered_questions?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo?.find(
                              (chapter) => chapter.name === value
                            );
                          dispatch(resetSelectedTopic());
                          if (selectedChapterObj) {
                            const chapterData = {
                              chapterTitle: selectedChapterObj.name,
                              chapterId: selectedChapterObj.chapterId,
                              chapterNo: selectedChapterObj.chapterNo,
                            };
                            dispatch(setSelectedChapter(chapterData));
                            getModuleQuestions({
                              selectedChapterId: chapterData.chapterId,
                            });
                            // selectedChapterId: selectedChapterObj.chapterId,
                          }
                        }
                      }}
                      optionList={
                        module_filtered_questions?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo.map(
                          (chapter) => {
                            return {
                              name: chapter.name,
                              selectedNumber: chapter.chapterNo,
                              id: chapter.chapterId,
                            };
                          }
                        ) || []
                      }
                      rootStyles={{
                        width: '100%',
                        height: {
                          xs: pxToRem(30),
                          md: pxTovW(75),
                          lg: pxTovW(56),
                        },
                      }}
                    />
                  </Box> */}

                  <ModifiedSelectMenu
                    header={'Search by Chapter'}
                    list={chapterList}
                    clearFunction={() => {
                      const tempTpList = createTopicList({
                        chapterList: createChapterList(
                          module_filtered_questions
                        ),
                        initialData: module_filtered_questions,
                      });
                      setChapterList((prevState) => {
                        const modifiedData = prevState?.map((item) => {
                          return { ...item, checked: false };
                        });
                        setTopicList(tempTpList);
                        return modifiedData;
                      });
                      getModuleQuestions({
                        latestTopicIds: tempTpList
                          .filter((elem) => elem.checked)
                          .map((elem) => elem.id),
                      });
                    }}
                    onChangeCheckbox={(listData) => {
                      setChapterList((prevState) => {
                        const modifiedData = prevState?.map((item) =>
                          item.id === listData.id
                            ? { ...item, checked: !item.checked }
                            : item
                        );
                        // keeping old topic checked state
                        let newTopicList = createTopicList({
                          chapterList: modifiedData,
                          initialData: module_filtered_questions,
                        });
                        setTopicList((prevTopics) => {
                          const modifiedTopicData = newTopicList.map((top) => {
                            const existing = prevTopics.find(
                              (t) => t.id === top.id
                            );
                            return {
                              ...top,
                              checked: existing?.checked ?? true,
                            };
                          });
                          newTopicList = modifiedTopicData; //modifiedTopicData needed later for api call
                          return modifiedTopicData;
                        });

                        getModuleQuestions({
                          latestChapterIds: modifiedData
                            .filter((elem) => elem.checked)
                            .map((elem) => elem.id),
                          latestTopicIds: newTopicList
                            .filter((elem) => elem.checked)
                            .map((elem) => elem.id),
                        });
                        return modifiedData;
                      });
                    }}
                  />

                  <ModifiedSelectMenu
                    header={'Search by Topic'}
                    list={topicList}
                    clearFunction={() => {
                      setTopicList((prevState) => {
                        return prevState?.map((item) => {
                          return { ...item, checked: false };
                        });
                      });
                      getModuleQuestions({
                        latestChapterIds: chapterList
                          .filter((elem) => elem.checked)
                          .map((elem) => elem.id),
                      });
                    }}
                    onChangeCheckbox={(listData) => {
                      setTopicList((prevState) => {
                        const modifiedData = prevState?.map((item) =>
                          item.id === listData.id
                            ? { ...item, checked: !item.checked }
                            : item
                        );

                        getModuleQuestions({
                          latestChapterIds: chapterList
                            .filter((elem) => elem.checked)
                            .map((elem) => elem.id),
                          latestTopicIds: modifiedData
                            .filter((elem) => elem.checked)
                            .map((elem) => elem.id),
                        });
                        return modifiedData;
                      });
                    }}
                  />
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        p: {
                          xs: `${pxToRem(8)} ${pxToRem(10)}`,
                          md: `${pxTovW(10)} ${pxTovW(12)}`,
                        },
                        borderRadius: { xs: pxToRem(5), md: pxTovW(10) },
                        border: '1px solid #0AA34F',
                        cursor: 'pointer',
                        background: '#CFFFE5',
                        display: 'flex',
                        alignItems: 'center',
                        gap: { xs: pxToRem(5), md: pxTovW(10) },
                      }}
                      onClick={() => {
                        setOpenFileUploadPopup(true);
                      }}
                    >
                      <Typography
                        variant="cardText"
                        color={'#007CDC'}
                        fontWeight={'600'}
                      >
                        + Add Your Own Questions
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}

          <Box sx={styles.selectContainer}>
            <Typography variant="h4" fontWeight={'bold'}>
              Question usage
            </Typography>
            {mediumScreen ? (
              <Autocomplete
                disablePortal
                id="question-usage-select"
                popupIcon={
                  <KeyboardArrowDownRoundedIcon
                    fontSize="large"
                    sx={{ color: 'text.disabled' }}
                  />
                }
                options={['Previously Used', 'Not Used', 'All']}
                value={selectedQuestionUsage}
                onChange={handleQuestionUsageChange}
                sx={{
                  border: '1px solid #38FF92',
                  borderRadius: '7px',
                  width: '100%',
                  '& .MuiInputBase-root': {
                    backgroundColor: 'initial',
                    '&:hover': { backgroundColor: 'initial' },
                    '&:focus': { backgroundColor: 'initial' },
                    '&:hover::before': { borderBottom: 'none' },
                    '&:focus::before': { borderBottom: 'none' },
                    '&::before': { borderBottom: 'none' },
                    '&::after': { borderBottom: 'none' },
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    variant="filled"
                    {...params}
                    label="Question usage"
                  />
                )}
              />
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  height: pxToRem(40),
                  border: '1px solid #38FF92',
                  borderRadius: '7px',
                  boxSizing: 'border-box',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: pxToRem(10),
                  width: '100%',
                }}
                onClick={() => setQuestionUsageModalState(true)}
              >
                <Typography
                  variant="h4"
                  sx={{
                    px: pxToRem(5),
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    wordBreak: 'break-word',
                  }}
                >
                  {selectedQuestionUsage ?? 'Question usage'}
                </Typography>
                <KeyboardArrowDownRoundedIcon sx={{ color: 'text.disabled' }} />
              </Box>
            )}
          </Box>
        </Box>

        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          {assesment_creation_type?.asessmentType ===
            AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                mb: pxToRem(8),
              }}
            >
              <Select
                value={userFilter?.value || 'all'}
                onChange={(e) => {
                  const val = e.target.value as 'all' | 'teacher';
                  setUserFilter({ value: val });
                  getModuleQuestions({
                    userId:
                      val === 'teacher'
                        ? user_info?.teacherProfileId
                        : undefined,
                  });
                }}
                displayEmpty
                renderValue={() => {
                  if (!userFilter?.value || userFilter.value === 'all') {
                    return (
                      <Typography variant="cardText"> All Questions</Typography>
                    );
                  }
                  return (
                    <Typography variant="cardText">
                      Teacher Uploaded Questions
                    </Typography>
                  );
                }}
                sx={{
                  background: '#F5FAFF',
                  width: { xs: '100%', md: pxTovW(332) },
                  borderRadius: { xs: pxToRem(10), md: pxTovW(5) },
                  height: { xs: pxToRem(50), md: pxTovW(50), lg: pxTovW(65) },
                  '.MuiOutlinedInput-notchedOutline': {
                    border: '2px solid #87C5FF',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    border: '2px solid #87C5FF',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: '2px solid #87C5FF',
                  },
                  boxShadow: 'none',
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      backgroundColor: '#F8FCFF',
                      '&::-webkit-scrollbar': { display: 'none' },
                      padding: 0,
                      borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
                      '& .MuiList-root': {
                        backgroundColor: '#F8FCFF',
                        maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                        padding: 0,
                      },
                      scrollbarWidth: 'thin',
                      minWidth: { xs: '95%', md: pxTovW(230) },
                      maxWidth: { xs: '95%', md: pxTovW(200), lg: pxTovW(150) },
                    },
                  },
                }}
              >
                <MenuItem value="all">All Questions</MenuItem>
                <MenuItem value="teacher">Teacher Uploaded Questions</MenuItem>
              </Select>
            </Box>
          )}
          {quesLoading ? (
            <Box sx={styles.questionBank}>
              <QuestionContainerShimmer />
            </Box>
          ) : (
            <Box sx={styles.questionBank}>
              {filteredQuestionsList?.questions.length &&
              filteredQuestionsList?.questions.length > 0 ? (
                <QuestionsBank
                  questionList={filteredQuestionsList?.questions}
                  handleAddNewQuestion={handleAddNewQuestion}
                  setQuestionBankDisplayFlag={setQuestionBankDisplayFlag}
                  selectedPage={selectedPage}
                  questionsPerPage={quePerPage || 20}
                  // handleDeleteNewQuestion={handleDeleteNewQuestion}
                  handleDeleteNewQuestion={(questionId) => {
                    setQuestionIdToDelete(questionId);
                  }}
                  fetchedQuestionModuleMap={fetchedQuestionModuleMap}
                />
              ) : (
                <NoContentCard
                  variant="info"
                  icon="cards"
                  text="No Questions available"
                />
              )}
            </Box>
          )}

          {totalPages > 1 && (
            <Pagination
              page={selectedPage}
              count={totalPages}
              color="primary"
              disabled={quesLoading}
              onChange={(event, page) => {
                if (quesLoading) return;
                setSelectedPage(page);
              }}
              sx={styles.paginationStyle}
            />
          )}
        </Box>
      </Box>

      <Box sx={styles.rightPanel} ref={rightPanelScrollTopRef}>
        {/* <QuestionsList
          title={
            <Typography
              variant="h2"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: { xs: pxToRem(10), md: pxTovW(10) },
              }}
            >
              My Assessment
              <Typography variant="h3" sx={{ display: 'inline' }}>
                <ChipBadge
                  label={module_filtered_questions?.questions.length}
                  color="primary"
                />
              </Typography>
            </Typography>
          }
        /> */}
        {/* <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'right',
            marginRight: pxTovW(20),
          }}
        >
          <Select
            value={userFilter || ''}
            onChange={(e) => {
              console.log('Selected filter:', e.target.value);
              setUserFilter({ value: e.target.value as 'all' | 'teacher' });
              getModuleQuestions({
                userId:
                  e.target.value === 'teacher'
                    ? user_info?.teacherProfileId
                    : undefined,
              });
            }}
            displayEmpty
            renderValue={(filter) => {
              if (!filter.value) {
                return <Typography color="text.disabled">Select</Typography>;
              }
              return filter.value === 'all' ? (
                <Typography variant="cardText"> All Questions</Typography>
              ) : (
                <Typography variant="cardText">
                  {' '}
                  Teacher Uploaded Questions
                </Typography>
              );
            }}
            sx={{
              background: '#F5FAFF',
              width: { xs: '100%', md: pxTovW(332) },
              borderRadius: { xs: pxToRem(10), md: pxTovW(5) },
              marginLeft: 'auto',
              height: { xs: pxToRem(50), md: pxTovW(50), lg: pxTovW(65) },
              '.MuiOutlinedInput-notchedOutline': {
                border: '2px solid #87C5FF',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                border: '2px solid #87C5FF',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: '2px solid #87C5FF',
              },
              boxShadow: 'none',
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  // maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                  // minHeight: { xs: 'max-content', md: 'max-content' },
                  backgroundColor: '#F8FCFF',
                  '&::-webkit-scrollbar': { display: 'none' },
                  padding: 0,
                  borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
                  '& .MuiList-root': {
                    backgroundColor: '#F8FCFF',
                    maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                    padding: 0,
                  },
                  scrollbarWidth: 'thin',
                  minWidth: { xs: '95%', md: pxTovW(230) },
                  maxWidth: { xs: '95%', md: pxTovW(200), lg: pxTovW(150) },
                },
              },
            }}
          >
            <MenuItem value="all">All Questions</MenuItem>
            <MenuItem value="teacher">Teacher Uploaded Questions</MenuItem>
          </Select>
        </Box> */}
        {assesment_creation_type?.asessmentType ===
          AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mb: pxTovW(10),
            }}
          >
            <Select
              value={userFilter?.value || 'all'}
              onChange={(e) => {
                const val = e.target.value as 'all' | 'teacher';
                setUserFilter({ value: val });
                getModuleQuestions({
                  userId:
                    val === 'teacher' ? user_info?.teacherProfileId : undefined,
                });
              }}
              displayEmpty
              renderValue={() => {
                if (!userFilter?.value || userFilter.value === 'all') {
                  return (
                    <Typography variant="cardText"> All Questions</Typography>
                  );
                }
                return (
                  <Typography variant="cardText">
                    Teacher Uploaded Questions
                  </Typography>
                );
              }}
              sx={{
                background: '#F5FAFF',
                width: { md: pxTovW(332) },
                borderRadius: { xs: pxToRem(10), md: pxTovW(5) },
                height: { xs: pxToRem(50), md: pxTovW(50), lg: pxTovW(65) },
                '.MuiOutlinedInput-notchedOutline': {
                  border: '2px solid #87C5FF',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: '2px solid #87C5FF',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: '2px solid #87C5FF',
                },
                boxShadow: 'none',
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: '#F8FCFF',
                    '&::-webkit-scrollbar': { display: 'none' },
                    padding: 0,
                    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
                    '& .MuiList-root': {
                      backgroundColor: '#F8FCFF',
                      maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                      padding: 0,
                    },
                    scrollbarWidth: 'thin',
                    minWidth: { xs: '95%', md: pxTovW(230) },
                    maxWidth: { xs: '95%', md: pxTovW(200), lg: pxTovW(150) },
                  },
                },
              }}
            >
              <MenuItem value="all">All Questions</MenuItem>
              <MenuItem value="teacher">Teacher Uploaded Questions</MenuItem>
            </Select>
          </Box>
        )}
        {quesLoading ? (
          <Box sx={styles.questionBank}>
            <QuestionContainerShimmer />
          </Box>
        ) : (
          <Box sx={styles.questionBank}>
            {filteredQuestionsList?.questions.length &&
            filteredQuestionsList?.questions.length > 0 ? (
              <QuestionsBank
                questionList={filteredQuestionsList?.questions}
                handleAddNewQuestion={handleAddNewQuestion}
                setQuestionBankDisplayFlag={setQuestionBankDisplayFlag}
                selectedPage={selectedPage}
                questionsPerPage={quePerPage || 20}
                // handleDeleteNewQuestion={handleDeleteNewQuestion}
                handleDeleteNewQuestion={(questionId) => {
                  setQuestionIdToDelete(questionId);
                }}
                fetchedQuestionModuleMap={fetchedQuestionModuleMap}
              />
            ) : (
              <NoContentCard
                variant="info"
                icon="cards"
                text="No Questions available"
              />
            )}
          </Box>
        )}

        {totalPages > 1 && (
          <Pagination
            page={selectedPage}
            count={totalPages}
            color="primary"
            disabled={quesLoading}
            onChange={(event, page) => {
              if (quesLoading) return;
              setSelectedPage(page);
            }}
            sx={styles.paginationStyle}
          />
        )}
      </Box>

      <MobilePopup
        options={difficultyValuesArray}
        title="DifficultyLevel"
        modalState={difficultyModalState}
        setModalState={setDifficultyModalState}
        onChange={handleDifficultyChange}
        clearall
      />

      <MobilePopup
        options={
          assesment_creation_type?.asessmentType ===
          AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT
            ? fa_assessment_config?.QuestionTypes.map((assessmentType) =>
                toStringQuestion(Question_QuestionEnum[assessmentType])
              ) || []
            : questionValuesArray
        }
        title="Question Type"
        modalState={quesTypeModalState}
        setModalState={setQuesTypeModalState}
        onChange={handleQuestionTypeChange}
        clearall
      />

      <MobilePopup
        options={bloomLevelValuesArray}
        title="Bloom Level"
        modalState={bloomLevelModalState}
        setModalState={setBloomLevelModalState}
        onChange={handleBloomLevelChange}
        clearall
      />

      <MobilePopup
        options={['Previously Used', 'Not Used', 'All']}
        title="Question usage"
        modalState={questionUsageModalState}
        setModalState={setQuestionUsageModalState}
        onChange={handleQuestionUsageChange}
      />

      <EditWarningPopup
        open={warningPopupOpen}
        handleClose={() => {
          setSelectedLogoClickHandler(() => handleLogoClick);
          setWarningPopupOpen(false);
        }}
        yesClickHandler={() => {
          dispatch(resetAssessmentFlowState());
          navigate(HOME);
          return;
        }}
        noClickHandler={() => {
          setSelectedLogoClickHandler(() => handleLogoClick);
          setWarningPopupOpen(false);
        }}
        iconname={'back'}
        text1={'If you go back, you may lose your changes.'}
        text2={'Are you sure you want go back?'}
      />

      <ActionsPopup
        open={!!questionIdToDelete}
        fontSmall={true}
        iconName="delete"
        popupText="Are you sure you want to Delete this Question ?"
        handleClose={() => setQuestionIdToDelete(undefined)}
        noClickHandler={() => setQuestionIdToDelete(undefined)}
        yesClickHandler={() => {
          questionIdToDelete && handleDeleteNewQuestion(questionIdToDelete);
          setQuestionIdToDelete(undefined);
        }}
      />

      <AddQuestionsPopup
        open={openFileUploadPopup}
        handleClose={() => {
          setFileUploading(false);
          setFile(undefined);
          setUploadStatusMessage({});
          setOpenFileUploadPopup(false);
        }}
        retryUploadFunction={() => {
          setFileUploading(false);
          setFile(undefined);
          setUploadStatusMessage({});
        }}
        downloadClickHandler={downloadTemplate}
        templateDownloading={templateDownloading}
        instructions={[
          'Download the question template from the DownLoad Template button',
          'Fill in your questions following the format specified in the template',
          'Ensure all required fields are completed (question text, options, correct answer, difficulty level)',
          'Save the file in .xlsx or .csv format',
          'Upload the completed file using the upload section below',
          'Review the uploaded questions before adding them to your question bank',
        ]}
        userUploadedFile={File}
        FileUploading={FileUploading}
        handleChangeFunction={(event) => {
          FileUpload(event.target.files as FileList);
          event.target.value = '';
        }}
        uploadStatusMessage={uploadStatusMessage}
        setUploadStatusMessage={setUploadStatusMessage}
      />
    </Box>
  );
}
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'black',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'black',
    borderRadius: '8px',
    fontSize: pxToRem(6), // Adjust tooltip font size if needed
  },
}));

interface IQuestionDeatails {
  teacherName: string;
  createdOn: Timestamp;
}
const TeacherUploadedButton = (props: IQuestionDeatails) => {
  const { teacherName, createdOn } = props;
  return (
    <BootstrapTooltip
      sx={{
        display: 'flex',
      }}
      title={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: pxToRem(8),
            padding: {
              xs: pxToRem(10),
              md: pxTovW(20),
            },
            border: '2px solid #FFFFFF',
            margin: pxToRem(10),
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: '#FFFFFF',
              lineHeight: '27px',
              fontFamily: 'Poppins',
            }}
          >
            Teacher Name: <span style={{ fontWeight: 700 }}>{teacherName}</span>
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: '#FFFFFF',
              lineHeight: '27px',
              fontFamily: 'Poppins',
            }}
          >
            Uploaded on:{' '}
            <span style={{ fontWeight: 700 }}>
              {getHumanReadableTimestampString(createdOn)}
            </span>
          </Typography>
        </Box>
      }
      arrow
      placement="top"
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: pxToRem(8),
          px: pxToRem(12),
          py: pxToRem(6),
          backgroundColor: '#FFF3CD',
          border: '1px solid #FFE69C',
          borderRadius: pxToRem(20),
          width: 'fit-content',
          cursor: 'pointer',
        }}
      >
        <PersonIcon
          sx={{
            fontSize: pxToRem(16),
            color: '#6C757D',
          }}
        />
        <Typography
          sx={{
            fontSize: pxToRem(12),
            fontWeight: 600,
            color: '#856404',
          }}
        >
          Teacher Uploaded
        </Typography>
      </Box>
    </BootstrapTooltip>
  );
};
